import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import { AppellateForm } from './AppellateForm';
import Notification, { notify } from '../../common/Notification/Notification';

storiesOf('Fillings/LocalCourtSearch/Forms/Appellate', module)
  .add('View', () => (
    <AppellateForm
      onSubmit={action('searchAppellate')}
      onClickSearchReset={action('resetLocalSearch')}
    />
  ))
  .add('Search error', () => (
    <div>
      <Notification/>
      <AppellateForm
        onSubmit={(...args) => {
          notify.error('Failed to search Appellate Local Court');
          action('searchAppellate')(...args);
        }}
        onClickSearchReset={action('resetLocalSearch')}
      />
    </div>
  ));



// WEBPACK FOOTER //
// ./src/components/search/localCourtSearch/AppellateForm.stories.jsx